export interface Vital {
  _id: string;
  memberId: string;
  vitals: Array<{
    name: string;
    value: string;
    unit?: string;
  }>;
  createdAt: string;
  updatedAt: string;
}

export enum VitalName {
  HEIGHT = "height",
  WEIGHT = "weight",
  STERILIZATION = "sterilization",
}

export enum UnitType {
  KG = "kg",
  FT_IN = "ft/in",
  CM = "cm",
}

export interface VitalDto {
  vitals: Array<{
    name: string;
    value: string;
    unit?: string;
  }>;
}

export type SterilizationStatus = "yes" | "no" | "unsure";

export const sterilizationOptions: {
  value: SterilizationStatus;
  label: string;
}[] = [
  { value: "yes", label: "Yes, my pet is sterilized" },
  { value: "no", label: "No, not sterilized yet" },
  { value: "unsure", label: "I'm not sure" },
];
